<template>
    <div>
        <Modal title="填写排单信息" v-model="modalShow" width="720px" @on-cancel="onCancel">
            <Alert type="warning" show-icon style="width:600px;margin-left:50px">
               拼单提示&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;已下单<span style="font-size:18px;color:#ff8800">&nbsp;&nbsp;{{orderedQuantity}}&nbsp;&nbsp;</span>片&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
               剩余最大拼单数量<span style="font-size:18px;color:#ff8800">&nbsp;&nbsp;{{mayQuantity}}&nbsp;&nbsp;</span>片
            </Alert>
            <Form style="margin-top:20px" ref="formValueRef" :model="factoryShareOrder" inline :rules="ruleValidate" :label-width="120">
                <FormItem label="联系人" prop="linkman">
                    <Input v-model="factoryShareOrder.linkman" clearable placeholder="请输入" style="width:200px"></Input>
                </FormItem>
                <FormItem label="联系人手机号" prop="phoneNumber">
                    <Input v-model="factoryShareOrder.phoneNumber" clearable placeholder="请输入" style="width:200px"></Input>
                </FormItem><br>
                <FormItem label="排单数量" prop="quantity">
                    <InputNumber v-model="factoryShareOrder.quantity" :min="1" :max="mayQuantity" clearable placeholder="请输入" style="width:200px"></InputNumber>
                </FormItem>
                <FormItem label="省市区">
                    <addr-cascader v-model="factoryShareOrder.areaId" style="width:200px" />
                </FormItem><br>
                <FormItem label="详细地址">
                    <Input type="textarea" v-model="factoryShareOrder.address" clearable style="width:530px"></Input>
                </FormItem>
            </Form>
            
            <div slot="footer">
                <Button type="warning" :loading="loading" @click="onSubmit">提交</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import { phoneNumRegx, chineseRegx } from '@/libs/constant/regx-const.js'

import addrCascader from '_c/select/addr-cascader.vue'
export default {
    components: {
        addrCascader
    },
    data() {
        return {
            modalShow: false,
            loading: false,
            minShareQuantity: "",
            orderedQuantity:'',//已下单
            mayQuantity:"",//可下单数量
            factoryShareOrder: {
                factoryPlanId: "",
                quantity: "",
                linkman: "",
                phoneNumber: "",
                areaId: "",
                address: ""
            },
            ruleValidate: {
                linkman: [{ required: true, message: "请输入联系人", }, { pattern: chineseRegx, message: "请输入中文名称" }],
                phoneNumber: [{ required: true, message: "请输入联系人手机号" }, { pattern: phoneNumRegx, message: "请输入正确手机号" }],
                quantity: [{ required: true, message: "请输入排单数量" }]
            }
        }
    },
    methods: {
        openModal(data) {
            this.factoryShareOrder.factoryPlanId = data.planId;
            this.minShareQuantity = data.minShareQuantity;
            this.orderedQuantity = data.orderedQuantity;
            this.mayQuantity = data.maxQuantity - data.orderedQuantity;
            this.modalShow = true
        },
        onCancel() {
            this.modalShow = false;
            this.$refs['formValueRef'].resetFields();
            this.factoryShareOrder.areaId = "";
            this.factoryShareOrder.address = "";
        },
        onSubmit() {
            this.$refs['formValueRef'].validate((valid) => {
                if (valid) {
                    if (this.factoryShareOrder.quantity < this.minShareQuantity) {
                        this.$Message.warning(`排单数量最少${this.minShareQuantity}片`);
                        return;
                    }
                    let data = {
                        url: "MID-CLIENT-MALL/messageService/factoryShareProductionService/addFactoryShareOrder",
                        body: { factoryShareOrder: this.factoryShareOrder }
                    }
                    this.loading = true;
                    this.invoke(data).then(res => {
                        if (!res) {
                            this.$Message.success('排单成功,请等待运营联系~')
                            this.loading = false;
                            this.$emit('refresh')
                            this.onCancel()
                        }
                    }).catch(err => this.loading = false)
                }
            })
        }
    }

}
</script>

<style lang="scss" scoped>
</style>